import httpClient from '../utils/axios'
import {
    handleServiceError,
    handleServiceResponse,
} from '../utils/serviceResponseHelper'

async function getAllAccessLevels(processEngineServiceId) {
    return httpClient
        .get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/accessLevel/${processEngineServiceId}`
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

async function createAccessLevel({ processEngineServiceId, title, isEnabled }) {
    const payload = {
        Title: title,
        IsEnabled: isEnabled,
    }

    return httpClient
        .post(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/accessLevel/${processEngineServiceId}`,
            payload,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

async function updateAccessLevel({
    processEngineServiceId,
    serviceAccessLevelId,
    title,
    isEnabled,
}) {
    const payload = {
        ServiceAccessLevelId: serviceAccessLevelId,
        Title: title,
        IsEnabled: isEnabled,
    }

    console.log(payload)

    return httpClient
        .put(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/accessLevel/${processEngineServiceId}`,
            payload,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
        .then(response => {
            return handleServiceResponse(response)
        })
        .catch(error => handleServiceError(error))
}

export default {
    getAllAccessLevels,
    createAccessLevel,
    updateAccessLevel,
}
